import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import Container from '../../../../../../elements/Container'
import Button from '../../../../../../elements/button'

import { useExperimentApi } from '../../../../../../store/api/hooks/experimentApiHook'
import { useNavigate, useParams } from 'react-router-dom'
import { URLS } from '../../../../../../_config'
import DataSelection from '../../../../../CreateExperiment/setScope/_components/uploadData/dataSelection'
import toast from 'react-hot-toast'
import Loader from '../../../../../../components/loader'
import DataFileUploader from '../../../../../../components/DataFileUploader'
import { SelectedDataTableType, UploadStatusType } from '../../../../../../_config/types'
import { useExperimentSelector } from '../../../../../../store/selectors/experimentSelector'
import { trackEvent } from '../../../../../../_common/functions'
import { startTiming, stopTiming } from '../../../../../../utils/analytics/rumTracking'
interface Props {
    popup?: boolean
    next: () => void
    experimentLiteral?: string
    onComplete?: (message: string) => void
    hidePreviousStep?: boolean
}
const RCTUploadData: React.FC<Props> = ({ next, popup = false, experimentLiteral, onComplete, hidePreviousStep }) => {
    const { t } = useTranslation()
    const navigate = useNavigate()
    const params = useParams()
    const experimentApi = useExperimentApi()
    const [working, setWorking] = useState<boolean>(false)
    const reduxExperiment = useExperimentSelector()
    const [fetchedExperiment, setFetchedExperiment] = useState<any>(null)

    const literal = experimentLiteral || params.experiment
    const experiment = experimentLiteral ? fetchedExperiment : reduxExperiment

    useEffect(() => {
        if (experimentLiteral) {
            experimentApi.getExperimentDetailsWatch(
                { literal: experimentLiteral + '?use_orm=true' },
                (resp: any) => {
                    setFetchedExperiment(resp)
                },
                (error: any) => {
                    toast.error(error?.message || 'Failed to fetch experiment details')
                },
            )
        }
    }, [experimentLiteral])

    const [fileUploader, setFileUploader] = useState<UploadStatusType>('ready-for-upload')

    const handleFileUploaderStatus = (status: UploadStatusType) => {
        if (status === 'uploading') {
            trackEvent('measurement_file_upload_started', { experiment_literal: literal, upload_type: 'measurement' })
        } else if (status === 'data-ready') {
            trackEvent('measurement_file_upload_success', { experiment_literal: literal, upload_type: 'measurement' })
        } else if (status === 'error') {
            trackEvent('measurement_file_upload_failed', { experiment_literal: literal, upload_type: 'measurement', error_message: 'File upload failed' })
        }
        setFileUploader(status)
    }

    const [selectedMeasurementTable, setSelectedMeasurementTable] = useState<SelectedDataTableType | null>(null)

    const handleMeasurementTableSelected = (table: SelectedDataTableType | null) => {
        if (table) {
            trackEvent('measurement_existing_table_selected', { experiment_literal: literal, table_name: table?.table?.name })
        }
        setSelectedMeasurementTable(table)
    }

    const GenerateDataQualityReport = () => {
        setWorking(true)
        startTiming('data_quality_report')
        experimentApi.generateDataQualityReport(
            {
                literal,
                table_name: selectedMeasurementTable?.table.name,
                upload_type: selectedMeasurementTable?.type,
            },
            (data: any) => {
                setWorking(false)
                stopTiming('data_quality_report', { literal: literal ?? '', upload_type: selectedMeasurementTable?.type ?? '' })
                goNext()
            },
            (error: any) => {
                setWorking(false)
                toast.error(error?.message)
            },
        )
    }

    const GoWithSelectedTable = () => {
        const paramsData = {
            delta_measurement_table_name: selectedMeasurementTable?.table?.name,
            literal,
        }
        setWorking(true)
        experimentApi.updateExperiment(
            paramsData,
            (data: any) => {
                setWorking(false)
                GenerateDataQualityReport()
            },
            (error: any) => {
                setWorking(false)
                toast.error(error?.message)
            },
        )
    }

    const GoWithFileUploader = () => {
        goNext()
    }

    const goNext = () => {
        if (onComplete) {
            onComplete('I have uploaded the measurement file')
        } else {
            next()
        }
    }

    const updateWithMeasurementTableData = () => {
        console.log('we have to call next....')
        if (selectedMeasurementTable) {
            GoWithSelectedTable()
        } else if (fileUploader == 'data-ready') {
            GoWithFileUploader()
        }
    }

    if (experimentLiteral && !fetchedExperiment) {
        return (
            <Container size="md" className="relative">
                <div className="flex justify-center items-center py-10">
                    <Loader />
                </div>
            </Container>
        )
    }

    return (
        <Container size="md" className="relative">
            {working && (
                <div className="flex justify-center items-center absolute z-10 top-0 left-0 w-full h-full bg-white bg-opacity-50">
                    <Loader />
                </div>
            )}
            {/* <div>Static msg</div> */}
            <div className={`flex items-center gap-2 p-1.5 ${popup ? 'justify-center' : 'justify-between'}`}>
                {!popup && (
                    <>
                        <div className={`w-[44%]  flex-shrink-0 my-4 `}>
                            {' '}
                            {/* ${selectedMeasurementTable ? 'opacity-50 pointer-events-none' : ''} */}
                            <DataFileUploader data-testid="uploader-measurement" literal={literal as string} uploadType="measurement" uploadingStatus={handleFileUploaderStatus} experimentData={experimentLiteral ? experiment : undefined} />
                        </div>

                        <div className="flex items-center justify-center leading-none text-[0.667rem] font-semibold w-[1.833rem] h-[1.833rem] bg-[#F4F4F4] border border-dashed border-[#BEBEBE] rounded-full">{t('OR')}</div>
                    </>
                )}

                <div className="w-[44%] flex-shrink-0 my-4">
                    <DataSelection data-testid="dataselection-measurement" _for="measurement" selectedDataTable={handleMeasurementTableSelected} experimentData={experimentLiteral ? experiment : undefined} />
                </div>
            </div>

            <div className="flex items-center justify-between my-4 px-1.5 ">
                <div className="flex items-center gap-3">
                    {!hidePreviousStep && !popup && !experiment?.is_rerun && experiment?.step != 6 && (
                        <Button
                            theme="secondary"
                            styleType="outline"
                            size="xs"
                            onClick={() => {
                                trackEvent('measurement_selection_previous_clicked', { experiment_literal: literal })
                                if (experiment?.is_measurement_flow) {
                                    void navigate(URLS.CREATE_EXPERIMENT(params.experiment) + '?step=0')
                                } else {
                                    void navigate(URLS.MY_EXPERIMENTS)
                                }
                            }}
                        >
                            {t('Previous Step')}
                        </Button>
                    )}
                </div>
                <div className="flex items-center gap-3">
                    <Button
                        theme="secondary"
                        size="xs"
                        className="text-white"
                        disabled={working ? true : !(fileUploader == 'data-ready' || selectedMeasurementTable)}
                        onClick={() => {
                            trackEvent('measurement_selection_next_clicked', { experiment_literal: literal, selection_type: selectedMeasurementTable ? 'existing_table' : 'file_upload' })
                            updateWithMeasurementTableData()
                        }}
                    >
                        {working ? <Loader /> : t('NEXT STEP')}
                    </Button>
                </div>
            </div>

            <div className="flex gap-2 items-center">
                {/* <Icon name="envelop" security="0.7rem" />
                <Text size="xs">
                    Having trouble submitting your information? If your <b>data</b> is <b>too large</b>, please reach out to us directly via <b>email</b>
                </Text> */}
            </div>
        </Container>
    )
}

export default RCTUploadData
